import Types from './types';

export function onChangeProjectSelected() {
	localStorage.removeItem('organization');
	localStorage.removeItem('company');
	return (dispatch) => dispatch({ type: Types.CHANGE_PROJECT_SELECTED });
}

export const clearOrganization = () => {
	return { type: Types.CLEAR_ORGANIZATION };
};

export const setOrganization = (parameters) => {
	return { type: Types.SET_ORGANIZATION, payload: parameters };
};

export const setCompany = (parameters) => {
	const { company, organization } = parameters;
	if (company && organization) {
		localStorage.setItem('company', JSON.stringify(company));
		localStorage.setItem('organization', JSON.stringify(organization));
	}
	return { type: Types.SET_COMPANY, payload: company };
};

const organizationActions = {
	setOrganization,
	setCompany
};

export default organizationActions;
